import { environment } from '../../../environments/environment';

export abstract class BaseService {
  protected get apiUrl(): string {
    return environment.apiUrl;
  }
}
